import * as actionTypes from './actionTypes';

const INITIAL_STATE = {
	status: null,
	error: null,
	loading: false,
	data: [],
	companiesWithEndUsers: []
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case actionTypes.GET_COMPANIES_LOADING:
			return {
				...state,
				loading: true
			};
		case actionTypes.GET_COMPANIES_SUCCESS:
			return {
				...state,
				status: 'loaded',
				loading: false,
				data: action.payload
			};
		case actionTypes.GET_COMPANIES_ERROR:
			return {
				...state,
				status: 'loaded',
				loading: false,
				error: action.payload
			};
		case actionTypes.START_FETCHING_COMPANIES_WITH_USERS:
			return {
				...state,
				loading: true
			};
		case actionTypes.GET_COMPANIES_WITH_USERS_SUCCESS:
			return {
				...state,
				status: 'success',
				loading: false,
				companiesWithEndUsers: action.payload,
			};
		case actionTypes.GET_COMPANIES_WITH_USERS_ERROR:
			return {
				...state,
				status: 'failed',
				loading: false,
				error: action.payload
			};
		default:
			return state;
	}
};
